<template>
  <div class="kpt-configurator-terminal">
    <div class="p-4 configurator-left">
      <b-carousel :indicator="false" :autoplay="false" v-if="terminalWizardPage == 0" class="mt-6">
        <b-carousel-item v-if="!terminalBeingBuilt || !terminalBeingBuilt.assets || terminalBeingBuilt.assets.length == 0">
          <span class="image">
            <img :src="require(`@/assets/configurator/placeholder.png`)" />
          </span>
        </b-carousel-item>
        <b-carousel-item v-else v-for="(asset, i) in terminalBeingBuilt.assets" :key="i">
          <span class="image">
            <img :src="`${assetCdnUrl}/${asset}`" />
          </span>
        </b-carousel-item>
      </b-carousel>
      <b-carousel :indicator="false" :autoplay="false" v-if="terminalWizardPage == 1">
        <template v-if="builtConnectivity.package == 'custom'">
          <b-carousel-item>
            <span class="image">
              <img :src="require(`@/assets/configurator/coverage/custom/global-custom.png`)" />
            </span>
          </b-carousel-item>
          <b-carousel-item>
            <span class="image">
              <img :src="require(`@/assets/configurator/coverage/custom/africa-india-custom.png`)" />
            </span>
          </b-carousel-item>
          <b-carousel-item>
            <span class="image">
              <img :src="require(`@/assets/configurator/coverage/custom/europe-me-custom.png`)" />
            </span>
          </b-carousel-item>
          <b-carousel-item>
            <span class="image">
              <img :src="require(`@/assets/configurator/coverage/custom/asia-custom.png`)" />
            </span>
          </b-carousel-item>
          <b-carousel-item>
            <span class="image">
              <img :src="require(`@/assets/configurator/coverage/custom/na-caribbean-custom.png`)" />
            </span>
          </b-carousel-item>
          <b-carousel-item>
            <span class="image">
              <img :src="require(`@/assets/configurator/coverage/custom/oceania-custom.png`)" />
            </span>
          </b-carousel-item>
          <b-carousel-item>
            <span class="image">
              <img :src="require(`@/assets/configurator/coverage/custom/s-america-custom.png`)" />
            </span>
          </b-carousel-item>
        </template>
        <template v-else>
          <template v-if="builtConnectivity.showTransecPackages">
            <b-carousel-item>
              <span class="image">
                <img :src="require(`@/assets/configurator/coverage/transec/europe-me-transec.png`)" />
              </span>
            </b-carousel-item>
            <b-carousel-item>
              <span class="image">
                <img :src="require(`@/assets/configurator/coverage/transec/africa-transec.png`)" />
              </span>
            </b-carousel-item>
            <b-carousel-item>
              <span class="image">
                <img :src="require(`@/assets/configurator/coverage/transec/na-caribbean-transec.png`)" />
              </span>
            </b-carousel-item>
          </template>
          <template v-else>
            <b-carousel-item>
              <span class="image">
                <img :src="require(`@/assets/configurator/coverage/Broadside-tiled.png`)" />
              </span>
            </b-carousel-item>
            <b-carousel-item>
              <span class="image">
                <img :src="require(`@/assets/configurator/coverage/Land-Mobile-tiled.png`)" />
              </span>
            </b-carousel-item>
            <b-carousel-item>
              <span class="image">
                <img :src="require(`@/assets/configurator/coverage/NA-Caribbean-broadside.png`)" />
              </span>
            </b-carousel-item>
            <b-carousel-item>
              <span class="image">
                <img :src="require(`@/assets/configurator/coverage/NA-Caribbean-mobile.png`)" />
              </span>
            </b-carousel-item>
            <b-carousel-item>
              <span class="image">
                <img :src="require(`@/assets/configurator/coverage/Europe-broadside.png`)" />
              </span>
            </b-carousel-item>
            <b-carousel-item>
              <span class="image">
                <img :src="require(`@/assets/configurator/coverage/Europe-mobile.png`)" />
              </span>
            </b-carousel-item>
            <b-carousel-item>
              <span class="image">
                <img :src="require(`@/assets/configurator/coverage/Asia-broadside.png`)" />
              </span>
            </b-carousel-item>
            <b-carousel-item>
              <span class="image">
                <img :src="require(`@/assets/configurator/coverage/Asia-mobile.png`)" />
              </span>
            </b-carousel-item>
            <b-carousel-item>
              <span class="image">
                <img :src="require(`@/assets/configurator/coverage/Africa-broadside.png`)" />
              </span>
            </b-carousel-item>
            <b-carousel-item>
              <span class="image">
                <img :src="require(`@/assets/configurator/coverage/Africa-mobile.png`)" />
              </span>
            </b-carousel-item>
          </template>
        </template>
      </b-carousel>
      <p v-if="showDisclaimer" class="has-text-danger has-text-centered">
        <span class="has-text-danger has-text-weight-bold mr-1">*</span>
        This product may not be available at this time. Please contact your sales person.
      </p>
      <configurator-estimated-total-component 
        v-if="showPrices"
        class="has-cursor-question" 
        @click.native="openPriceDetailModal" 
        :msrp-total="msrpTotal"
        :msrp-monthly="builtConnectivity.selectedPlan ? builtConnectivity.selectedPlan.msrpPrice * builtTerminal.quantity : 0"
        :wholesale-total="wholesaleTotal" 
        :wholesale-monthly="builtConnectivity.selectedPlan ? builtConnectivity.selectedPlan.wholesalePrice * builtTerminal.quantity : 0"
        :wholesale="wholesale"
        :is-custom="builtConnectivity.package == 'custom'"
        :show-monthly="terminalWizardPage == 1 && builtConnectivity.isInterested"
      />
    </div>
    <div class="configurator-right has-background-white" ref="configuratorRight">
      <b-tabs class="has-hidden-tabs configurator-tabs" v-model="terminalWizardPage">
        <!-- Terminal Hardware -->
        <b-tab-item>
          <h1 class="title">Kymeta u8 Terminal</h1>
          <section class="configurator-section configurator-item-desc">
            <label class="label has-text-black-bis has-text-weight-bold">Description</label>
            <p v-if="(!terminalBeingBuilt || !terminalBeingBuilt.name)">Not found.</p>
            <p v-else v-html="terminalBeingBuilt.name"></p>
          </section>
          <!-- Market Selection -->
          <section class="configurator-section">
            <label class="label has-text-black-bis has-text-weight-bold">Market</label>
            <div>
              <div v-for="item in availableMarkets" :key="item.id">
                <b-tooltip style="width: 100%" type="is-warning" label="Please contact a sales representative." :active="item.id == 'military'">
                  <b-radio-button
                    v-model="builtTerminal.market"
                    :native-value="item.id"
                    type="is-primary is-light is-outlined"
                    :disabled="item.id == 'military'"
                    @input="marketTypeToggled"
                    class="mb-1 has-text-black-bis has-text-weight-bold is-fullwidth">                
                    <span>{{ item.name }}</span>
                  </b-radio-button>
                </b-tooltip>
              </div>
              <template v-if="builtTerminal.market">
              </template> 
              <!-- Disabled/removed as requested by Product team... the intent is for military customers to contact a sales representative directly
                <div class="mt-2 columns" v-if="builtTerminal.market == 'military'">
                <div class="column is-one-quarter">
                  <b-radio-button type="is-primary is-light is-outlined" v-model="builtTerminal.color" native-value="green">
                    Green
                  </b-radio-button>
                </div>
                <div class="column is-one-quarter">
                  <b-radio-button type="is-primary is-light is-outlined" v-model="builtTerminal.color" native-value="tan">
                    Tan <span class="has-text-danger has-text-weight-bold ml-1">*</span>
                  </b-radio-button>
                </div>
                <div class="column is-one-quarter">
                  <b-radio-button type="is-primary is-light is-outlined" v-model="builtTerminal.color" native-value="grey">
                    Grey <span class="has-text-danger has-text-weight-bold ml-1">*</span>
                  </b-radio-button>
                </div>
                <div class="column is-one-quarter">
                  <b-radio-button type="is-primary is-light is-outlined" v-model="builtTerminal.color" native-value="white">
                    White <span class="has-text-danger has-text-weight-bold ml-1">*</span>
                  </b-radio-button>
                </div>
              </div> -->
            </div>
            <span class="is-clickable pl-4">
              <!-- display appropriate modal content based on the selected market -->
              <b-icon icon="info-circle" @click.native="openHelperModal('market-commercial', 'Commercial Enterprise')" v-if="builtTerminal.market === 'enterpriseCommercial'"></b-icon>
              <b-icon icon="info-circle" @click.native="openHelperModal('market-government', 'Government')" v-if="builtTerminal.market === 'government'"></b-icon>
              <b-icon icon="info-circle" @click.native="openHelperModal('market-military', 'Military')" v-if="builtTerminal.market === 'military'"></b-icon>
            </span>
          </section>
          <!-- When Market is "Military" inform users to contact a sales representative directly -->
          <div v-if="builtTerminal.market == 'military'">
            <b-message 
              title="Military Notice" 
              type="is-warning" 
              has-icon 
              :closable="false">
              <div class="mt-3">Please contact a sales representative.</div>
          </b-message>
          </div>
          <div v-else>
            <!-- Application Selection -->
            <section class="configurator-section">
              <label class="label has-text-black-bis has-text-weight-bold">Application</label>
              <div class="level mb-2">
                <div class="level-left">
                  <div class="level-item" v-for="item in availableApplications" :key="item.id">
                    <b-radio-button
                      v-model="builtTerminal.application"
                      :native-value="item.id"
                      type="is-primary is-light is-outlined"
                      @input="applicationTypeToggled"
                      class="has-text-black-bis has-text-weight-bold">
                      <span>{{ item.name }}</span>
                    </b-radio-button>
                  </div>
                </div>
              </div>
              <span>&nbsp;</span>
            </section>
            <!-- Modem Selection -->
            <section class="configurator-section">
              <label class="label has-text-black-bis has-text-weight-bold">Modem</label>
              <div>
                <b-radio-button
                  v-model="builtTerminal.modem"
                  :native-value="item.id"
                  type="is-primary is-light is-outlined"
                  v-for="item in availableModems"
                  :key="item.id"
                  @input="modemTypeToggled"
                  class="mb-1 has-text-black-bis has-text-weight-bold">
                  <span style="width: 100%" class="has-text-left">{{ item.name }}</span>
                </b-radio-button>
              </div>
              <span class="is-clickable pl-4">
                <b-icon icon="info-circle" @click.native="openHelperModal('modem', 'Modem')"></b-icon>
              </span>
            </section>
            <!-- BUC Selection -->
            <section class="configurator-section">
              <label class="label has-text-black-bis has-text-weight-bold">BUC</label>
              <div class="level mb-2">
                <div class="level-left">
                  <div class="level-item" v-for="item in availableBucs" :key="item.id">
                    <b-radio-button v-model="builtTerminal.buc" :native-value="item.id" type="is-primary is-light is-outlined" class="has-text-black-bis has-text-weight-bold">
                      <span>{{ item.name }}</span>
                    </b-radio-button>
                  </div>
                </div>
              </div>
              <span class="is-clickable pl-4"></span>
            </section>
            <!-- SD-WAN Selection -->
            <section class="configurator-section">
              <label class="label has-text-black-bis has-text-weight-bold">SD-WAN</label>
              <div>
                <b-radio-button
                  v-model="builtTerminal.sdwan"
                  :native-value="item.id"
                  type="is-primary is-light is-outlined"
                  v-for="item in availableSdwans"
                  :key="item.id"
                  class="mb-1 has-text-black-bis has-text-weight-bold">
                  <span>{{ item.name }}</span>
                </b-radio-button>
              </div>
              <span class="is-clickable pl-4">
                <b-icon icon="info-circle" @click.native="openHelperModal('sdwan', 'SD-WAN', '640px')"></b-icon>
              </span>
            </section>
            <!-- Cases section -->
            <template v-if="availableCases && availableCases.length">
              <section class="configurator-section">
                <label class="label has-text-black-bis has-text-weight-bold">Case</label>
                <div>
                  <b-radio-button
                    v-model="builtTerminal.terminalCase"
                    :native-value="item.id"
                    type="is-primary is-light is-outlined"
                    v-for="item in availableCases"
                    :key="item.id"
                    class="mb-1 has-text-black-bis has-text-weight-bold">
                    <span style="width: 100%" class="has-text-left">{{ item.name }}</span>
                  </b-radio-button>
                </div>
                <span class="is-clickable pl-4">
                  <b-icon icon="info-circle" @click.native="openHelperModal('case', 'u8 GO Case')"></b-icon>
                </span>
              </section>
            </template>
            <!-- Warranty Section -->
            <section class="configurator-section">
              <label class="label has-text-black-bis has-text-weight-bold">Warranty</label>
              <div>
                <b-radio-button
                  v-model="builtTerminal.warranty"
                  :native-value="item.id"
                  type="is-primary is-light is-outlined"
                  v-for="item in availableWarranties"
                  :disabled="isWarrantyOptionDisabled(item.id)"
                  :key="item.id"
                  class="mb-1 has-text-black-bis has-text-weight-bold">
                  <span style="width: 100%" class="has-text-left">{{ item.name }}</span>
                </b-radio-button>
              </div>
              <span class="is-clickable pl-4">
                <b-icon icon="info-circle" @click.native="openHelperModal('warranty', 'Kymeta™ u8 Products Limited Warranty')"></b-icon>
              </span>
            </section>
            <!-- Quantity Section -->
            <section class="configurator-section quantity-selector">
              <label class="label has-text-black-bis has-text-weight-bold">Quantity</label>
              <div class="is-flex">
                <label class="label mr-4">Terminals:</label>
                <b-field style="width: 125px; margin-bottom: 0">
                  <b-numberinput
                    size="is-small"
                    max="999"
                    min="1"
                    v-model="builtTerminal.quantity"
                  ></b-numberinput>
                </b-field>
              </div>
              <span></span>
            </section>
            <!-- Accessories Section -->
            <section class="configurator-section">
              <label class="label has-text-black-bis has-text-weight-bold">Accessories</label>
              <div>
                <table class="table is-narrow">
                  <thead>
                    <tr>
                      <th></th>
                      <th class="has-text-centered">Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(accessory, i) in availableAccessoriesList" :key="i">
                      <td class="has-text-black-bis has-text-weight-bold">
                        {{ accessory.name }}
                        <span class="has-text-danger has-text-weight-bold ml-1" v-if="accessory.unavailable">*</span>
                      </td>
                      <td>
                        <b-field style="width: 125px; margin-bottom: 0">
                          <b-numberinput
                            @keyup.native="verifyMaxQuantity(accessory.kpc)"
                            size="is-small"
                            max="999"
                            min="0"
                            v-model="builtTerminal.accessories[accessory.kpc]"
                          ></b-numberinput>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <b-message class="mb-1" type="is-info" v-if="builtTerminal.modem == 'none' && builtTerminal.antenna == 'u8'">You didn't select a modem. We recommend adding the Rx, Tx Data for ODU cable to connect to your own modem.</b-message>
                <b-message type="is-info" v-if="builtTerminal.terminalCase != 'none'">Note: The u8 GO configuration includes both the AC-to-DC Power Kit and vehicle mounting solutions.</b-message>
              </div>
              <span class="is-clickable pl-4">
                <b-icon icon="info-circle" @click.native="openHelperModal('accessories', 'Accessories')"></b-icon>
              </span>
            </section>
            <!-- Connectivity Interest Section -->
            <section class="configurator-section">
              <label class="label has-text-black-bis has-text-weight-bold">Connectivity</label>
              <div>
                <b-field label="Are you interested in a connectivity package?">
                  <b-radio-button v-model="builtConnectivity.isInterested" :native-value="true" :disabled="builtTerminal.modem == 'oneweb'" type="is-primary is-light is-outlined" class="mr-2"><span>Yes</span></b-radio-button>
                  <b-radio-button v-model="builtConnectivity.isInterested" :native-value="false" :disabled="builtTerminal.modem == 'oneweb'" type="is-primary is-light is-outlined" class="mr-2"><span>No</span></b-radio-button>
                </b-field>
              </div>            
            </section>
            <!-- Wizard Navigation Selection -->
            <section class="configurator-section next-section">
              <span></span> <!-- void one of the grid cells to align the buttons to the right -->
              <span>
                <span v-if="builtConnectivity.isInterested">
                  <b-button
                    rounded
                    expanded
                    size="is-small"
                    type="is-dark"
                    @click="$store.commit('configurator/setTerminalWizardPage', 1)"
                    class="is-uppercase">
                    Next
                  </b-button>
                </span>
                <span v-else>
                  <div v-if="terminalUnderEdit == null">
                    <b-button rounded expanded size="is-small" type="is-dark" @click="addToCart" class="is-uppercase">Add To Cart</b-button>
                  </div>
                  <div v-else>
                    <b-button rounded expanded size="is-small" type="is-dark" @click="updateCartItem" class="is-uppercase">Update Cart Item</b-button>
                  </div>
                </span>
              </span>
            </section>
          </div>
        </b-tab-item>
        <!-- Connectivity -->
        <b-tab-item>
          <h1 class="title">Kymeta Broadband</h1>
          <p>Kymeta™ Broadband, uniquely designed for the Kymeta u8 terminals, provides internet access via satellite or hybrid satellite/cellular networks on a user-defined basis.</p>
          <br>
          <p>Satellite capacity is offered via a Kymeta-managed network that aggregates multiple satellite providers. Cellular capacity is offered via a Kymeta partner that provides service via hundreds of direct operator partnerships for global coverage via a single SIM. Traffic is routed dynamically between satellite and cellular to provide optimal routing in multi-coverage regions. All with a single monthly bill.</p>
          <br />
          <p class="has-text-weight-semibold">Please fill out the questions below if you are looking for connectivity.</p>
          <hr />
          <template v-if="builtConnectivity.isInterested">
            <section class="configurator-section-cn">
              <b-field label="What connectivity package are you looking for?">
                <b-radio-button v-model="builtConnectivity.package" native-value="idk" type="is-primary is-light is-outlined" class="mr-2"><span>I don't know</span></b-radio-button>
                <!-- <b-radio-button v-model="builtConnectivity.package" native-value="standard" type="is-primary is-light is-outlined" class="mr-2"><span>Standard</span></b-radio-button> -->
                <b-radio-button v-model="builtConnectivity.package" native-value="custom" type="is-primary is-light is-outlined" class="mr-2"><span>Custom</span></b-radio-button>
              </b-field>
            </section>
            <template v-if="builtConnectivity.package == 'idk'">
              <section class="configurator-section-cn">
                <b-field label="How many users/devices will connect to a terminal?">
                  <b-radio-button v-model="builtConnectivity.users" :native-value="1" type="is-primary is-light is-outlined" class="mr-2">1</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.users" :native-value="2" type="is-primary is-light is-outlined" class="mr-2">2</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.users" :native-value="3" type="is-primary is-light is-outlined" class="mr-2">3</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.users" :native-value="5" type="is-primary is-light is-outlined" class="mr-2">4+</b-radio-button>
                </b-field>
              </section>
              <section class="configurator-section-cn">
                <b-field label="How many days per month will a terminal be in use?">
                  <b-radio-button v-model="builtConnectivity.days" :native-value="3" type="is-primary is-light is-outlined" class="mr-2">&lt; 5</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.days" :native-value="8" type="is-primary is-light is-outlined" class="mr-2">6 to 10</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.days" :native-value="16" type="is-primary is-light is-outlined" class="mr-2">11 to 20</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.days" :native-value="31" type="is-primary is-light is-outlined" class="mr-2">21+</b-radio-button>
                </b-field>
              </section>
              <section class="configurator-section-cn">
                <b-field label="How many hours per day will a terminal be used for email and web browsing?">
                  <b-radio-button v-model="builtConnectivity.dataUsage" :native-value="0" type="is-primary is-light is-outlined" class="mr-2">0</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.dataUsage" :native-value="0.4" type="is-primary is-light is-outlined" class="mr-2">&lt; 2</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.dataUsage" :native-value="0.8" type="is-primary is-light is-outlined" class="mr-2">2 to 5</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.dataUsage" :native-value="1.6" type="is-primary is-light is-outlined" class="mr-2">5 to 10</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.dataUsage" :native-value="9.6" type="is-primary is-light is-outlined" class="mr-2">10+</b-radio-button>
                </b-field>
              </section>
              <section class="configurator-section-cn">
                <b-field label="How many hours per day will a terminal be used for voice only or audio applications?">
                  <b-radio-button v-model="builtConnectivity.voiceUsage" :native-value="0" type="is-primary is-light is-outlined" class="mr-2">0</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.voiceUsage" :native-value="0.8" type="is-primary is-light is-outlined" class="mr-2">&lt; 2</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.voiceUsage" :native-value="1.6" type="is-primary is-light is-outlined" class="mr-2">2 to 5</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.voiceUsage" :native-value="3.2" type="is-primary is-light is-outlined" class="mr-2">5 to 10</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.voiceUsage" :native-value="9.6" type="is-primary is-light is-outlined" class="mr-2">10+</b-radio-button>
                </b-field>
              </section>
              <section class="configurator-section-cn">
                <b-field label="How many hours per day will a terminal be used for video calls or streaming SD videos?">
                  <b-radio-button v-model="builtConnectivity.streamingUsage" :native-value="0" type="is-primary is-light is-outlined" class="mr-2">0</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.streamingUsage" :native-value="0.375" type="is-primary is-light is-outlined" class="mr-2">&lt; 2</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.streamingUsage" :native-value="1.125" type="is-primary is-light is-outlined" class="mr-2">2 to 5</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.streamingUsage" :native-value="6" type="is-primary is-light is-outlined" class="mr-2">5 to 10</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.streamingUsage" :native-value="18" type="is-primary is-light is-outlined" class="mr-2">10+</b-radio-button>
                </b-field>
              </section>
              <section class="configurator-section-cn">
                <b-field label="How many hours per day will a terminal be used for HD video calls or streaming HD videos?">
                  <b-radio-button v-model="builtConnectivity.hdStreamingUsage" :native-value="0" type="is-primary is-light is-outlined" class="mr-2">0</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.hdStreamingUsage" :native-value="1" type="is-primary is-light is-outlined" class="mr-2">&lt; 2</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.hdStreamingUsage" :native-value="3" type="is-primary is-light is-outlined" class="mr-2">2 to 5</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.hdStreamingUsage" :native-value="16" type="is-primary is-light is-outlined" class="mr-2">5 to 10</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.hdStreamingUsage" :native-value="48" type="is-primary is-light is-outlined" class="mr-2">10+</b-radio-button>
                </b-field>
              </section>
              <section class="configurator-section-cn">
                <b-field label="Do you require a minimum data rate / CIR throughput?">
                  <b-radio-button v-model="builtConnectivity.minDataRequired" :native-value="true" type="is-primary is-light is-outlined" class="mr-2">Yes</b-radio-button>
                  <b-radio-button v-model="builtConnectivity.minDataRequired" :native-value="false" type="is-primary is-light is-outlined" class="mr-2">No</b-radio-button>
                </b-field>
              </section>
              <section class="configurator-section conn-recommendation">
                <label class="label" :title="connectivityQuestionsScore">Our Recommendation</label>
                <p v-if="builtConnectivity.minDataRequired">A custom connectivity plan is recommended. Select <a @click="builtConnectivity.package = 'custom'">'Custom Plan'</a> above to request custom connectivity.</p>
                <div v-else>
                  <b-radio-button
                    v-model="builtConnectivity.selectedPlan"
                    :native-value="item"
                    type="is-primary is-light is-outlined"
                    v-for="item in recommendedPackages"
                    :key="item.score"
                    class="mb-1 has-text-black-bis has-text-weight-bold">
                    <span style="width: 100%" class="has-text-left">{{
                      item.name
                    }}</span>
                  </b-radio-button>
                </div>
              </section>
            </template>
            <template v-if="builtConnectivity.package == 'standard'">
              <section class="configurator-section">
                <label class="label has-text-black-bis has-text-weight-bold">Kymeta Broadband</label>
                <div>
                  <b-radio-button 
                    v-if="availableConnectivity.includes('standard')"
                    v-model="builtConnectivity.showTransecPackages"
                    :native-value="false" 
                    type="is-primary is-light is-outlined" 
                    class="mb-1 has-text-black-bis has-text-weight-bold">
                      <span style="width: 100%" class="has-text-left">Standard Connectivity, 5x2, Global</span>
                  </b-radio-button>
                  <b-radio-button 
                    v-model="builtConnectivity.showTransecPackages" 
                    v-if="availableConnectivity.includes('transec')"
                    :native-value="true" 
                    type="is-primary is-light is-outlined" 
                    class="mb-1 has-text-black-bis has-text-weight-bold">
                      <span style="width: 100%" class="has-text-left">TRANSEC Connectivity, 5x2, Global</span>
                  </b-radio-button>
                </div>
                <span class="is-clickable pl-4">
                  <b-icon icon="info-circle" @click.native="openHelperModal('connectivity', 'Kymeta™ Broadband Connectivity')"></b-icon>
                </span>
              </section>
              <section class="configurator-section">
                <label class="label" :title="connectivityQuestionsScore">Data Package</label>
                <div>
                  <div v-if="builtConnectivity.showTransecPackages">
                    <b-radio-button
                      v-model="builtConnectivity.selectedPlan"
                      :native-value="item"
                      type="is-primary is-light is-outlined"
                      v-for="item in transecConnectivityPackages"
                      :key="item.score"
                      class="mb-1 has-text-black-bis has-text-weight-bold">
                      <span style="width: 100%" class="has-text-left">{{item.name}}</span>
                    </b-radio-button>
                  </div>
                  <div v-else>
                    <b-radio-button
                      v-model="builtConnectivity.selectedPlan"
                      :native-value="item"
                      type="is-primary is-light is-outlined"
                      v-for="item in nonTransecConnectivityPackages"
                      :key="item.score"
                      class="mb-1 has-text-black-bis has-text-weight-bold">
                      <span style="width: 100%" class="has-text-left">{{item.name}}</span>
                    </b-radio-button>
                  </div>
                </div>
                <span class="is-clickable pl-4">
                  <b-icon icon="info-circle" @click.native="openHelperModal('connectivity', 'Kymeta™ Broadband Connectivity')"></b-icon>
                </span>
              </section>
            </template>
            <template v-if="builtConnectivity.package == 'custom'">
              <section>
                <label class="label">What customized connectivity configuration are you looking for?</label>
                <b-input type="textarea" v-model="builtConnectivity.customConfigurationText" maxlength="999"></b-input>
                <p class="mt-2">
                  <strong>Note: </strong>After you submit your quote request, a Kymeta connectivity specialist will reach out to help customize a connectivity plan that works for you.
                </p>
              </section>
            </template>
          </template>
          <section class="is-flex is-justify-content-space-between" style="border-bottom: 0; padding-top: 0.75rem; padding-bottom: 0.75rem;">
            <div>
              <b-button rounded expanded size="is-small" type="is-dark" @click="$store.commit('configurator/setTerminalWizardPage', 0)" >BACK TO TERMINAL</b-button>
            </div>
            <div v-if="terminalUnderEdit == null">
              <b-button rounded expanded size="is-small" type="is-dark" @click="addToCart">ADD CONFIGURATION TO CART</b-button>
            </div>
            <div v-else>
              <b-button rounded expanded size="is-small" type="is-dark" @click="updateCartItem">UPDATE CONFIGURATION</b-button>
            </div>
          </section>
        </b-tab-item>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import { v4 as uuidv4 } from 'uuid';
import { intersection } from 'lodash';
import { 
  computed, 
  reactive, 
  watch, 
  ref,
  getCurrentInstance
} from 'vue';
import wizardToCartItem from './cartItemBuilder';
import ConfiguratorEstimatedTotalComponent from './ConfiguratorEstimatedTotalComponent.vue';
import ConfiguratorModal from './modals/ConfiguratorModal.vue';
import ConfiguratorPriceDetailModal from './modals/ConfiguratorPriceDetailModal.vue';

export default {
  components: {
    ConfiguratorEstimatedTotalComponent,
  },
  setup(props) {
    const app = getCurrentInstance();
    const root = app.proxy.$root;
    const configuratorRight = ref(null);
    // Permissions
    const configuratorPermissions = computed(() => root.$store.getters['configurator/configuratorPermissions']);
    // Analytics
    const am = computed(() => root.$store.getters['configurator/analyticsMetadata']);
    // Products and Accessories
    const allProducts = computed(() => root.$store.getters['configurator/allProducts']);
    const allAccessories = computed(() => root.$store.getters['configurator/accessories']);
    // Connectivity
    const allConnectivity = computed(() => root.$store.getters['configurator/connectivity'] || []);
    const nonTransecConnectivityPackages = computed(() => allConnectivity?.value.filter(t => !t.name.includes('TRANSEC')) || []);
    const transecConnectivityPackages = computed(() => allConnectivity?.value.filter(t => t.name.includes('TRANSEC')) || []);
    // Various REF()s from the store
    const activeTab = computed(() => root.$store.state.configurator.activePage);
    const terminalWizardPage = computed(() => root.$store.state.configurator.terminalWizardPage);
    const wholesale = computed(() => root.$store.state.configurator.wholesale);
    const showPrices = computed(() => root.$store.state.configurator.showPrices);
    const terminalUnderEdit = computed(() => root.$store.state.configurator.cartItemUnderEdit);
    
    /*
      RULES IMPORT & DERIVATES
      Rules file is imported and derivative 'availableX' computed properties are generated
    */
    // #region Rules
    const configuratorRules = computed(() => root.$store.getters['configurator/rules']);
    // #endregion

    // #region Default State + Reset
    const defaultTerminalValues = {
      market: 'enterpriseCommercial',
      application: 'landMobile',
      quantity: 1,
      modem: 'iq200',
      buc: '20watt',
      color: 'white',
      sdwan: 'globalent',
      terminalCase: 'none',
      accessories: Object.fromEntries(allAccessories.value.map(a => [a.kpc, 0])), // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
      warranty: '12'
    }

    const defaultGovTerminalValues = {
      market: 'government',
      application: 'landMobile',
      quantity: 1,
      modem: '950mp',
      buc: '20watt',
      color: 'white',
      sdwan: 'globalent',
      terminalCase: 'none',
      accessories: Object.fromEntries(allAccessories.value.map(a => [a.kpc, 0])), // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
      warranty: '12'
    }

    const defaultMilTerminalValues = {
      market: 'military',
      application: 'military',
      quantity: 1,
      modem: '950mp',
      buc: '20watt',
      color: 'green',
      sdwan: 'globalent',
      terminalCase: 'none',
      accessories: Object.fromEntries(allAccessories.value.map(a => [a.kpc, 0])),
      warranty: '12'
    }

    const defaultConnectivityValues = {
      isInterested: true,
      // idk package selections
      package: 'idk',
      users: 2,
      days: 8,
      dataUsage: 0.4,
      voiceUsage: 0.8,
      streamingUsage: 0.375,
      hdStreamingUsage: 1,
      minDataRequired: false,
      // standard package selections
      showTransecPackages: false,
      // custom package selections
      customConfigurationText: '',
      selectedPlan: allConnectivity.value[2]
    }

    const defaultValues = !configuratorPermissions.value?.commercialPriceBook ? defaultMilTerminalValues : defaultTerminalValues;

    // Apparently spread operator creates references to sub-objects (accessories) rather than cloning them 
    // Have to use the parse/stringify trick to do a deepclone
    const builtTerminal = reactive(JSON.parse(JSON.stringify(defaultValues)));
    const builtConnectivity = reactive(JSON.parse(JSON.stringify(defaultConnectivityValues)));
    const resetTerminalConfigurator = () => {
      Object.assign(builtTerminal, JSON.parse(JSON.stringify(defaultValues))); // https://github.com/vuejs/vue-next/issues/1081#issuecomment-621385050
      Object.assign(builtConnectivity, JSON.parse(JSON.stringify(defaultConnectivityValues)));
      // reset the selected plan too
      builtConnectivity.selectedPlan = allConnectivity.value[2];
    }
    // #endregion

    // #region Built accessories
    // Used to render accessories in HTML
    const availableMarkets = computed(() => {
      const rules = configuratorRules.value;
      let markets = Object.keys(rules).map(key => ({
        id: key,
        name: rules[key].name
      }));
      if (!configuratorPermissions.value?.commercialPriceBook) markets = markets.filter(a => a.id != 'enterpriseCommercial');
      if (!configuratorPermissions.value?.militaryPriceBook) markets = markets.filter(a => a.id != 'military');
      return markets;
    });

    const availableApplications = computed(() => {
      const rules = configuratorRules.value[builtTerminal?.market];
      const apps = Object.keys(rules)
        .filter(k => k != 'name')
        .map(key => ({ id: key, name: rules[key].name }));
      return apps;
    });

    const availableModems = computed(() => {
      const rules = configuratorRules.value[builtTerminal?.market][builtTerminal?.application];
      return rules.availableModems;
    });

    const availableBucs = computed(() => {
      const bucs = configuratorRules.value[builtTerminal?.market][builtTerminal?.application].availableBucs;
      const rules = bucs[`modem.${builtTerminal?.modem}`];
      return rules;
    });

    const availableSdwans = computed(() => {
      const rules = configuratorRules.value[builtTerminal?.market][builtTerminal?.application];
      const sdwanForCurrentModem = rules.availableSdwans[`modem.${builtTerminal?.modem}`];
      return sdwanForCurrentModem;
    });

    const availableCases = computed(() => {
      const rules = configuratorRules.value[builtTerminal?.market][builtTerminal?.application];
      const casesForCurrentModem = rules.availableCases[`modem.${builtTerminal?.modem}`];
      return casesForCurrentModem;
    });

    const availableWarranties = computed(() => {
      const rules = configuratorRules.value[builtTerminal?.market][builtTerminal?.application];
      return rules.availableWarranties;
    });

    const availableAccessoriesList = computed(() => {
      const rules = configuratorRules.value[builtTerminal?.market][builtTerminal?.application];
      const allAccessoriesForCase = rules.availableAccessories[`case.${builtTerminal?.terminalCase}`]?.all;
      const accessoriesForCurrentModem = rules.availableAccessories[`case.${builtTerminal?.terminalCase}`][`modem.${builtTerminal?.modem}`];
      const allAvailableAccessoryKpcs = allAccessoriesForCase.concat(accessoriesForCurrentModem);

      return allAccessories.value.filter(a => allAvailableAccessoryKpcs.includes(a.id));
    });

    const availableConnectivity = computed(() => {
      const rules = configuratorRules.value[builtTerminal?.market][builtTerminal?.application];
      const allConnectivityForMarket = rules.availableConnectivity.all;
      const connectivityForModem = rules.availableConnectivity[`modem.${builtTerminal?.modem}`];
      return allConnectivityForMarket.concat(connectivityForModem);
    });
    // #endregion

    // #region Toggling Antenna type
    const marketTypeToggled = (value) => {
      // TODO: Remove this and just reset the default choices for builtTerminal every time the button is toggled
      if (value == 'military') {
        Object.assign(builtTerminal, JSON.parse(JSON.stringify(defaultMilTerminalValues)));
      } else if (value == 'government') {
        Object.assign(builtTerminal, JSON.parse(JSON.stringify(defaultGovTerminalValues)));
      } else {
        Object.assign(builtTerminal, JSON.parse(JSON.stringify(defaultTerminalValues)));
      }
    }
    // #endregion

    // #region Toggling Application type
    const applicationTypeToggled = (value) => {
      if (value == 'maritime') {
        builtTerminal.modem = 'oneweb';
        builtTerminal.buc = 'onewebbuc';
        builtTerminal.terminalCase = 'none';
        builtConnectivity.isInterested = false;
      }
      if (value == 'landFixed') {
        builtTerminal.modem = 'oneweb';
        builtTerminal.buc = 'none';
      }
    }
    // #endregion

    // #region TRANSEC Checks
    const canShowTransecConnectivityOptions = computed(() => builtTerminal.modem == '950mp');
    const isTransecPlan = (plan) => plan?.name?.toLowerCase().includes('transec');
    // #endregion

    const openHelperModal = (content, title, width) => {
      root.$buefy.modal.open({
        hasModalCard: true,
        component: ConfiguratorModal,
        trapFocus: true,
        width: 960,
        props: {
          content,
          title,
          width: width || '960px'
        }
      });

      root.$kya.event('configurator', 'openInfoModalOnTerminalPage', 'Opened an info modal during terminal configuration.', am.value);
    }

    // #region Verify the accessory quantity can't go above 999
    const verifyMaxQuantity = (id) => {
      if (builtTerminal.accessories[id] > 999) builtTerminal.accessories[id] = 999;
    }
    // #endregion

    // #region Modem Type selection was made, so adjust supporting hardware options
    const modemTypeToggled = (value) => {
      // if iq200, hide transec plans and if a transec plan is already selected, reset it
      if (value === 'iq200') {
        builtConnectivity.showTransecPackages = false;
        if (isTransecPlan(builtConnectivity.selectedPlan)) {
          // eslint-disable-next-line prefer-destructuring
          builtConnectivity.selectedPlan = nonTransecConnectivityPackages.value[2];
        }
      }
      // if user changes modem to none, set the sdwan to none... also if user changes modem to 950mp, reset it to globalent
      if (value === '950mp' && builtTerminal.sdwan == 'none') {
        builtTerminal.sdwan = 'globalent'; // this resets the sdwan
      } else if (value === 'none' && builtTerminal.market == 'military') {
        builtTerminal.sdwan = 'globalent'; // if mil terminal and no modem selected, still select global ent
      } else if (value === 'none' && builtTerminal.market == 'enterpriseCommercial') {
        builtTerminal.sdwan = 'none'; // regular u8
      }
      if (value === 'oneweb') {
        // oneweb has specific buc and sdwan options that should be automatically selected when this modem type is chosen
        builtTerminal.buc = 'onewebbuc';
        builtTerminal.sdwan = 'globalent';
        builtTerminal.terminalCase = 'none';
        // default connectivity interest to false (also disables the selection)
        builtConnectivity.isInterested = false;
      } else {
        // default buc to 'none' for landFixed
        if (builtTerminal.application == 'landFixed') {
          builtTerminal.buc = 'none';
        } else {
          // when oneweb modem is not selected, reset default buc to 20watt
          builtTerminal.buc = '20watt';
        }
        // default to true when modem is not oneweb
        builtConnectivity.isInterested = true;
      }
    }
    // #endregion

    // #region Calculate the connectivity recommendation
    const connectivityQuestionsScore = computed(() => builtConnectivity.users + builtConnectivity.days + builtConnectivity.dataUsage + builtConnectivity.voiceUsage + builtConnectivity.streamingUsage + builtConnectivity.hdStreamingUsage);
    const recommendedPackageIndex = computed(() => {
      const cscore = connectivityQuestionsScore.value;
      if (cscore > 121) return nonTransecConnectivityPackages.value.findIndex(p => p.score == 121);
      if (cscore > 81) return nonTransecConnectivityPackages.value.findIndex(p => p.score == 81);
      if (cscore > 41) return nonTransecConnectivityPackages.value.findIndex(p => p.score == 41)
      if (cscore > 21) return nonTransecConnectivityPackages.value.findIndex(p => p.score == 21)
      if (cscore > 11) return nonTransecConnectivityPackages.value.findIndex(p => p.score == 11)
      if (cscore > 6) return nonTransecConnectivityPackages.value.findIndex(p => p.score == 6)
      return nonTransecConnectivityPackages.value.findIndex(p => p.score == 0)
    });
    const recommendedPackages = computed(() => {
      // if index is 0, return only 0 and 1
      // if index is 1-5, return 0 and 2
      // if index is 6, return 5 and 6
      if (recommendedPackageIndex.value == 0) return [nonTransecConnectivityPackages.value[0], nonTransecConnectivityPackages.value[1]];
      if (recommendedPackageIndex.value > 0 && recommendedPackageIndex.value < 6) {
        return [
          nonTransecConnectivityPackages.value[recommendedPackageIndex.value - 1],
          nonTransecConnectivityPackages.value[recommendedPackageIndex.value],
          nonTransecConnectivityPackages.value[recommendedPackageIndex.value + 1]
        ];
      }
      return [nonTransecConnectivityPackages.value[5], nonTransecConnectivityPackages.value[6]];
    });
    // set the default package
    builtConnectivity.selectedPlan = nonTransecConnectivityPackages.value[recommendedPackageIndex.value];
    // when the recommendation changes, update the selection
    watch(recommendedPackageIndex, (newValue) => {
      builtConnectivity.selectedPlan = nonTransecConnectivityPackages.value[newValue];
    });
    // #endregion

    // #region Prepare for price calculations
    // First, we need to get the terminal price 'stamp' based on the selection options
    const terminalPriceStamp = computed(() => `${builtTerminal.market}-${builtTerminal.application}-${builtTerminal.modem}-${builtTerminal.terminalCase}-${builtTerminal.sdwan}-${builtTerminal.buc}-${builtTerminal.color}`);
    // Then we get the terminal KPC from the dictionary
    const terminalKpc = computed(() => root.$store.getters['configurator/kpcDictionary'][terminalPriceStamp.value]);
    // Then, we find the actual terminal by indexing via the kpc
    const terminalBeingBuilt = computed(() => root.$store.getters['configurator/allProductsIndex'][terminalKpc.value]);
    // Now let's do the same for the warranty
    const warrantyPriceStamp = computed(() => `${builtTerminal.market}-${builtTerminal.application}-${builtTerminal.modem}-${builtTerminal.terminalCase}-warranty`);
    const warrantyKpc = computed(() => root.$store.getters['configurator/kpcDictionary'][warrantyPriceStamp.value]);
    const chosenWarranty = computed(() => root.$store.getters['configurator/allProductsIndex'][warrantyKpc.value]);
    // The warranty multiplier is used below to calculate the estimated price
    // Get the month amount from the name, subtract the first 12 months (included), then divide by 12 to get the number of extra warranty years
    const chosenWarrantyMultiplier = computed(() => (parseInt(builtTerminal.warranty, 10) - 12) / 12)
    const connectivityKpc = computed(() => builtConnectivity.selectedPlan?.kpc);
    // #endregion

    // #region watchers - logging changes
    watch(terminalPriceStamp, (newValue) => console.log(`Terminal Stamp: ${newValue}`));
    watch(warrantyPriceStamp, (newValue) => console.log(`Warranty Stamp: ${newValue}`));
    // watch(terminalBeingBuilt, (newValue) => console.log(`Terminal Being Built: `, newValue));
    // #endregion

    /*
      TOTAL CALCULATIONS
      1. Terminal price based on the terminalBeingBuilt variable
      2. Warranty price based on chosenWarranty * chosenWarrantyMultiplier
      3. Chosen accessories price * chosen quantity
      4. Chosen connectivity package
    */

    // #region Calculate Total
    // Lastly we need to see which accessories were chosen by seeing which of the values on the accessories object are greater than 0
    const chosenAccessories = computed(() => {
      // First we need to filter out only the accessories which have a value > 0
      const chosen = Object.entries(builtTerminal.accessories).filter(kvp => kvp[1] > 0);
      // Then convert it back to an object
      const chosenObject = Object.fromEntries(chosen);
      // Lastly, from available accessories, we filter out only the ones we added a positive quantity to
      // And then add that quantity via .map()
      const chosenArray = allAccessories.value.filter(a => Object.keys(chosenObject).includes(a.kpc)).map(ac => ({ ...ac, quantity: chosenObject[ac.kpc] }));
      return chosenArray;
    });

    // Then we build the total based on the base price from the pricing object + any accessories
    const wholesaleTotal = computed(() => {
      // Aggregated accessory cost
      const chosenAccessoriesPrice = chosenAccessories.value.map(a => a?.wholesalePrice * a.quantity).reduce((a, b) => a + b, 0);
      // If customer selected a warranty, add that too
      const warrantyPrice = builtTerminal.warranty === '12mo-factory-warranty' ? 0 : chosenWarranty.value?.wholesalePrice * (chosenWarrantyMultiplier.value);
      // Return the (terminal price + accessory price + warranty price) * quantity
      return chosenAccessoriesPrice + ((terminalBeingBuilt.value?.wholesalePrice + warrantyPrice) * builtTerminal.quantity);
    });
    
    // Repeat above, just for MSRP
    const msrpTotal = computed(() => {
      const chosenAccessoriesPrice = chosenAccessories.value.map(a => a?.msrpPrice * a.quantity).reduce((a, b) => a + b, 0);
      const warrantyPrice = builtTerminal.warranty === '12mo-factory-warranty' ? 0 : chosenWarranty.value?.msrpPrice * (chosenWarrantyMultiplier.value);
      return chosenAccessoriesPrice + ((terminalBeingBuilt.value?.msrpPrice + warrantyPrice) * builtTerminal.quantity);
    });
    // #endregion

    // this method checks when editing if the financing is greater than the warranty and disables the warranty
    // only valid when editing since when we're adding, financing is 1
    const isWarrantyOptionDisabled = (warrantyDuration) => parseInt(warrantyDuration, 10) < terminalUnderEdit.value?.financing;

    // #region Disclaimer
    const showDisclaimer = computed(() => {
      const unavailableKPCs = allProducts.value.filter(p => p.unavailable).map(p => p.kpc);
      const intersectingValues = intersection(chosenAccessories.value.map(v => v.kpc), unavailableKPCs);
      return (unavailableKPCs.includes(terminalKpc.value) || !!(intersectingValues.length)) && terminalWizardPage.value == 0;
    });
    // #endregion

    const validateUserSelections = () => {
      // verify we found a matching Product provided by Salesforce
      if (!terminalBeingBuilt || !terminalBeingBuilt.value) {
        root.$buefy.snackbar.open({
          message: 'The selection you have chosen is not currently available.',
          type: 'is-danger',
          duration: 3500,
          position: 'is-bottom',
          actionText: 'OK',
          indefinite: false
        });
        return false;
      }
      // user has chosen to configure connectivity
      if (builtConnectivity.isInterested) {
        // connectivity check first
        if (builtConnectivity.package == 'idk' && builtConnectivity.minDataRequired == true) {
          root.$buefy.snackbar.open({
            message: 'Please select a custom plan or update your answers to add a connectivity plan to your configuration.',
            type: 'is-danger',
            duration: 3500,
            position: 'is-bottom',
            actionText: 'OK',
            indefinite: false
          });
          return false;
        }
        if (builtConnectivity.package == 'custom' && !(builtConnectivity.customConfigurationText)) {
          root.$buefy.snackbar.open({
            message: 'Please provide information on your customized connectivity needs to proceed.',
            type: 'is-danger',
            duration: 3500,
            position: 'is-bottom',
            actionText: 'OK',
            indefinite: false
          });
          return false;
        }
      }

      // passed validation checks
      return true;
    }
    
    const addToCart = () => {
      const isValid = validateUserSelections();
      if (!isValid) return;
      const ct = wizardToCartItem({ 
        ...builtTerminal, 
        kpc: terminalKpc.value, 
        name: terminalBeingBuilt.value.name 
      }, 
      {
        ...builtConnectivity,
        kpc: connectivityKpc.value
      }, 
      { 
        kpc: warrantyKpc.value, 
        count: chosenWarrantyMultiplier.value,
        originalCount: chosenWarrantyMultiplier.value
      });

      // add terminal to cart
      root.$store.commit('configurator/addToCart', ct);
      chosenAccessories.value.forEach(accessory => {
        const cartAccessory = {
          quantity: accessory.quantity,
          kpc: accessory.kpc,
          id: uuidv4(),
          item: {
            name: accessory.name
          }
        }
        root.$store.commit('configurator/addToCart', cartAccessory);
      })

      root.$kya.event('configurator', 'addToCart', 'Added a terminal configuration to cart.', { ...am.value, item: ct });

      root.$store.commit('configurator/setActivePage', 2);
    };

    const updateCartItem = () => {
      const isValid = validateUserSelections();
      if (!isValid) return;

      const ct = wizardToCartItem({ 
        ...builtTerminal, 
        kpc: terminalKpc.value, 
        name: terminalBeingBuilt.value.name 
      }, 
      {
        ...builtConnectivity,
        kpc: connectivityKpc.value
      }, 
      { 
        kpc: warrantyKpc.value, 
        count: chosenWarrantyMultiplier.value,
        originalCount: chosenWarrantyMultiplier.value
      },
      // pass in financing and id of existing cart item
      terminalUnderEdit.value.financing,
      terminalUnderEdit.value.id);

      // commit to store
      root.$store.commit('configurator/editCartItem', ct);

      // reset the edit object
      root.$store.commit('configurator/setCartItemUnderEdit', null);

      // add event
      root.$kya.event('configurator', 'updateCartItem', 'Updated a terminal configuration in the cart.', { ...am.value, item: ct });

      // redirect
      root.$store.commit('configurator/setActivePage', 2);
    }

    // Watch if we leave this tab and reset the terminal configurator
    watch(activeTab, (newValue, oldValue) => {
      if (oldValue == 1) {
        resetTerminalConfigurator();
        root.$store.commit('configurator/setTerminalWizardPage', 0);
      }
      // we just came from shopping cart and there's a terminalunderedit present = we're editing
      if (oldValue == 2 && terminalUnderEdit.value != null) {
        // user clicked Edit in the shopping cart, so let's use their original selection to pre-populate the wizard
        Object.assign(builtTerminal, JSON.parse(JSON.stringify(terminalUnderEdit.value.originalBuiltTerminal)));
        Object.assign(builtConnectivity, JSON.parse(JSON.stringify(terminalUnderEdit.value.originalBuiltConnectivity)));
        if (builtConnectivity.isInterested) {
          builtConnectivity.selectedPlan = allConnectivity.value.find(p => p.kpc == builtConnectivity.selectedPlan.kpc);
        }
      }
    });

    watch(terminalWizardPage, () => {
      // eslint-disable-next-line no-param-reassign
      configuratorRight.scrollTop = 0;
    });

    const openPriceDetailModal = () => {
      root.$buefy.modal.open({
        hasModalCard: true,
        component: ConfiguratorPriceDetailModal,
        trapFocus: true,
        props: {
          terminalBeingBuilt,
          builtTerminal,
          chosenAccessories,
          warranty: {
            priceObject: chosenWarranty.value,
            quantity: chosenWarrantyMultiplier.value
          },
          wholesale: wholesale.value
        }
      });

      root.$kya.event('configurator', 'openPriceDetail', 'Opened price detail pop-up in Terminal Configurator.', am.value);
    }

    const assetCdnUrl = computed(() => root.$store.state.appConfig.assetCdnUrl);

    return {
      terminalWizardPage,
      builtTerminal,
      builtConnectivity,
      allAccessories,
      addToCart,
      wholesale,
      msrpTotal,
      wholesaleTotal,
      openHelperModal,
      openPriceDetailModal,
      verifyMaxQuantity,
      modemTypeToggled,
      terminalBeingBuilt,
      recommendedPackages,
      connectivityQuestionsScore,
      nonTransecConnectivityPackages,
      transecConnectivityPackages,
      showPrices,
      canShowTransecConnectivityOptions,
      terminalUnderEdit,
      updateCartItem,
      isWarrantyOptionDisabled,
      marketTypeToggled,
      applicationTypeToggled,
      availableAccessoriesList,
      availableMarkets,
      availableApplications,
      availableModems,
      availableBucs,
      availableSdwans,
      availableCases,
      availableWarranties,
      availableConnectivity,
      showDisclaimer,
      assetCdnUrl
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/colors";

.kpt-configurator-terminal {
  display: grid;
  grid-template-columns: 1fr minmax(200px, 50%);
  height: calc(100vh - 48px);
  position: relative;

  @media screen and (max-width: 800px) {
    display: block;
  }

  .configurator-right {
    overflow: auto;
    position: relative;
    padding: 1rem;
    @supports (-webkit-touch-callout: none) {
      height: calc(100% - 2rem); // mac only
    }
  }

  .configurator-left {
    position: relative;
    @supports (-webkit-touch-callout: none) {
      height: calc(100% - 1rem); // mac only
    }
    
  }

  .configurator-section {
    display: grid;
    grid-template-columns: 110px 1fr auto;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    margin-bottom: 0.75rem;
    border-bottom: 1px solid $grey-light;

    &.quantity-selector {
      grid-template-columns: 110px 1fr;
      align-items: center;
    }

    &.next-section {
      grid-template-columns: 1fr 200px;
      align-items: center;
      border-bottom: 0;
    }

    &.conn-recommendation {
      grid-template-columns: 200px 1fr;
    }
  }

  // override css formatting for html from Salesforce
  .configurator-item-desc {
    ::v-deep p:first-of-type {
      margin-top: 0px;
    }
    ::v-deep ul {
      list-style-type: disc;
    }
    ::v-deep ul, ::v-deep ol {
      li { 
        margin-left: 2rem; 
      }
      li:first-of-type {
        margin-top: 8px;
      }
      li:last-of-type {
        margin-bottom: 8px;
      }
    }
  }

  .configurator-section-cn {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    margin-bottom: 0.75rem;
    border-bottom: 1px solid $grey-light;
  }
}
</style>
